/**
 * Diwali under the header: a marigold garland along its edge. Hidden unless that theme shows it
 * (globals.css, Diwali's rangoli-and-marigolds effect). Decoration, never in the way.
 */
export function HeaderLights() {
  return (
    <div aria-hidden className="header-lights">
      <span className="garland-edge" />
    </div>
  )
}
